module.exports = {"340222100":"繁阳镇","340222101":"荻港镇","340222102":"孙村镇","340222103":"平铺镇","340222104":"新港镇","340222105":"峨山镇","340222400":"横山公共服务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340222.json
// module id = 969
// module chunks = 0